import React, { useEffect, useState } from "react";
import { Col, Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "./table.css";

const WholesalerModal = ({
  handleClose,
  show,
  wholesalertimelsot,
  handleTimeslot,
  selectWholesaler,
  handleDelete,
  handleExecutiveChange,
  allwholesaler,
  companyExecutiveList,
  options,
  disable,
  wholesaler,
  timeslots,
  allValues,
  setAllValues,
  timeslot,
  value,
  rangestate,
  wholesaleListSave,
  currentEventId,
  onSaveEvent,
  onCancelEvent,
}) => {

 const [error, setError] = useState("");

  useEffect(() => {
    if (show && currentEventId) {
      const currentEventValues = value.wholesalerIds?.filter(
        (item) => String(item.event_id) === String(currentEventId)
      );

      setAllValues(currentEventValues || []);

      setError("");
    }
  }, [show, currentEventId]);

  const handleSave = () => {
    if (!allValues || allValues.length === 0) { 
      toast.error("Please select at least 1 Wholesaler");
       return;
       }

    if (allValues.some((item) => !item.executive_id)) {
      setError("Please select Executive for all wholesalers");
      return;
    }

    setError("");

    const val = {
      ...value,
      rangestate: rangestate,
    };

    wholesaleListSave(val);

    onSaveEvent?.(currentEventId);

    handleClose();
  };

  const handleModalClose = () => {
    setError("");

   onCancelEvent?.(currentEventId);

    handleClose();
  };

  return (
    <Modal show={show} onHide={handleModalClose} size="lg" centered  className="modal-center-custom">
      <Modal.Header closeButton >
        <Modal.Title>Select Wholesaler</Modal.Title>
      </Modal.Header>

      <ToastContainer />

      <Modal.Body>
        {/* {allwholesaler.length > 0 ?

                    <div className="row" style={{ columns: 'auto 2', margin: '20px', padding: '10px' }}>

                        <Form.Label>Event Timeslot:</Form.Label>

                        <select name="contact_question_option" className="select_questions" style={{
                            border: '1px solid #dddddd',
                            borderRadius: '5px',
                            padding: '15px 15px',
                            width: '100%',
                            transition: 'all 0.5s ease'
                        }}

                            onChange={(e) => handleTimeslot(e)}
                            disabled={disable}
                            value={timeslot}
                        >
                            <option style={{
                                fontSize: '14px',
                                fontWeight: 400,
                                fontFamily: "Uniform"
                            }}

                                value="">Select Time</option>
                            {
                                options.map((val, index) => {
                                    return (
                                        <option value={val.value}>{val.value}</option>
                                    )

                                }
                                )
                            }

                        </select>
                    </div>
                    : ''} */}

        <div
          className="row"
          style={{ columns: "auto 2", margin: "20px", padding: "10px" }}
        >
          <Form.Label>Select Wholesaler:</Form.Label>

          {allwholesaler.length > 0 ? (
            <Col xs="12" sm="12" style={{ textAlign: "left" }}>
              <select
                name="contact_question_option"
                className="select_questions"
                style={{
                  border: "1px solid #dddddd",
                  borderRadius: "5px",
                  padding: "15px 15px",
                  width: "100%",
                  transition: "all 0.5s ease",
                }}
                onChange={(e) => selectWholesaler(e)}
                disabled={disable}
                value={wholesaler}
              >
                <option
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,

                    fontFamily: "Uniform",
                  }}
                  value=""
                >
                  Select Wholesaler
                </option>
                {allwholesaler.map((val, idx) => {
                  return (
                    <option value={val.customer_id} data-name={val.first_name}>
                      {val.company_name}
                    </option>
                  );
                })}
              </select>
            </Col>
          ) : (
            ""
          )}
        </div>

        {allValues.length > 0 ? (
          <div
            className="row"
            style={{ columns: "auto 2", margin: "20px", padding: "10px" }}
          >
            <Col xs="12" sm="12" style={{ textAlign: "left", margin: "12px" }}>
              <table  style={{margin:"15px 0", width: "100%"}}>
                <thead>
                  <tr>
                    {/* <th>Timeslot</th> */}
                    <th>Wholesaler Name</th>
                    <th>Executive</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {allValues.map((val, idx) => {
                    return (
                      <tr>
                        {/* <td data-column="First Name">{val.timeslot} </td> */}
                        <td data-column="Last Name"> {val.name}</td>
                            <td data-column="Executive">
                        <select
                          name={`company_executive_${idx}`}
                          className="select_questions"
                          required
                          style={{
                            border: "1px solid #dddddd",
                            borderRadius: "5px",
                            padding: "10px",
                            width: "100%",
                            minWidth: "180px",
                          }}
                          value={ val.executive_id || "" }
                          onChange={(e) => {
                            handleExecutiveChange(e, idx);
                            setError("");
                          }}
                          disabled={disable}
                        >
                          <option value="">
                            Select Executive
                          </option>
                            {companyExecutiveList?.map((executive, executiveIndex) => {
                              return (
                                <option
                                  key={executive.company_executive_id || executiveIndex}
                                  value={executive.company_executive_id}
                                >
                                  {executive.company_executive_name?.trim()}
                                </option>
                              );
                            })}
                        </select>
                      </td>
                        <td
                          data-column="Job Title"
                            style={{
                            textAlign:"center"
                          }}
                        >
                          <Button
                            variant="secondary"
                            name={val.name}
                            onClick={(e) => handleDelete(e, idx)}
                          >
                            <i class="bx  bx-x"></i>
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

               {error && (
                <span
                  style={{
                    color: "red",
                    textAlign: "center",
                    marginTop: "5px",
                    fontSize: "16px",
                    display: "block",
                    fontWeight: "500",
                  }}
                >
                  {error}
                </span>
              )}
              
            </Col>
          </div>
        ) : (
          ""
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>
          Close
        </Button>
        <Button variant="success" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WholesalerModal;